module.exports = __webpack_public_path__ + "static/media/confirmation-icon.11bea679.svg";